import WorkOrderPriority from "./workOrderPriority";

const getDisplayValue = (workOrderPriority: WorkOrderPriority) => {
  let displayValue = "";

  switch (workOrderPriority) {
    case WorkOrderPriority.P1Emergency:
      displayValue = "P1 Emergency";
      break;

    case WorkOrderPriority.P2SameDayService:
      displayValue = "P2 Same Day Service";
      break;

    case WorkOrderPriority.P3NextDayService:
      displayValue = "P3 Next Day Service";
      break;

    case WorkOrderPriority.P4ScheduledService:
      displayValue = "P4 Scheduled Service";
      break;

    case WorkOrderPriority.P5PreventativeServices:
      displayValue = "P5 Preventative Services";
      break;

    default:
      displayValue = workOrderPriority;
      break;
  }

  return displayValue;
};

const workOrderPriorityHelper = {
  getDisplayValue,
};

export default workOrderPriorityHelper;
